import { styled,TextField,
  Button,
  FormControl,
  MenuItem,
  Select,
  Typography, } from "@mui/material";
  import HelpIcon from "@mui/icons-material/Help";
export const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 911,
  height: 639,
  borderRadius: "12px",
  bgcolor: "var(--Card-Background, #FAFAFA)",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
};

export const successStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 911,
  height: 301,
  borderRadius: "12px",
  bgcolor: "var(--Card-Background, #FAFAFA)",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
};

export const ErrorDiv = styled("div")(() => ({
  color: "var(--Warning-Red, #E52B24)",
  position: "absolute",
  top: 25,
  bottom: 955,
  right: 80,
  left: 50,
  height: 39,
  width: 885,
  fontFamily: "Calibri",
  fontSize: 22,
  fontWeight: 400,
  textAlign: "center",
  lineHeight: "normal",
  fontStyle: "normal",
}));

export const CloseImg = styled('img')(() => ({
  position: "absolute",
  top: 12,
  right: 28,
  bottom:611,
  left:870,
  width: 16,
  height: 16,
  fill: "var(--Dark-Gray, #666461)",
}));

export const CreatePipelineHeader = styled('h1')(() => ({
  position: "absolute",
  top: 2,
  right: 325,
  left:326,
  bottom:589,
  height:39,
  width:260,
  color: "var(--Black, #333230)",
  textAlign: "center",
  fontFamily: "Calibri",
  fontSize: 32,
  fontStyle: "normal",
  fontWeight: "300",
  lineHeight: "normal",
}));

export const FieldNameText = styled(Typography)(() => ({
  fontFamily: "Calibri",
  fontSize: 19,
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
}));

export const PipelineNameTextField = styled(TextField)(() => ({
  width: 450,
  height: 34,
  borderRadius: 6,
  border: "2px solid var(--Dark-Gray, #666461)",
  background: "var(--Whiteish-Gray, #FDFBF9)",
}));

export const FieldNameSpan = styled('span')(() => ({
  color: "var(--Warning-Red, #E52B24)",
  fontFamily: "Calibri",
  fontSize: 20,
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal",
}));

export const CreatePipelineHelpIcon = styled(HelpIcon)(() => ({
  height: 20,
  width: 20,
  left: 2,
  fill: "var(--Dark-Gray, #666461)",
}));

export const SelectDropDown = styled(Select)(() => ({
  width: 450,
  height: 34,
  borderRadius: 6,
  border: "2px solid var(--Dark-Gray, #666461)",
  background: "var(--Whiteish-Gray, #FDFBF9)",
}));

export const SelectMenuItem = styled(MenuItem)(() => ({
  color: "#999590",
  opacity: 0,
  font: "Cambria",
}));

export const CreatePipelineButton = styled(Button)(() => ({
  width: 750,
  height: 50,
  alignContent: "center",
  background:
    "var(--Medium-Green, var(--color-brand-Green-Medium, #7CBA25))",
  borderRadius: "12px",
  "&:hover": {
    background:
      "var(--color-brand-Green-Medium, #7CBA25)",
  },
})); 

export const CheckmarkImg = styled('img')(() => ({
  position: "absolute",
  top: 107,
  bottom: 44,
  right: 380,
  left: 381,
  width: "150px",
  height: "150px",
}));

export const CreateFormControl = styled(FormControl)(() => ({
  paddingLeft: 8, top:72, left:69, marginTop:20
}));
